/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import numericalFieldHandler from "../../../utils/numericalFieldHandler";
import translateLabel from "../../../utils/translateLabel";

interface Props {
  id: string;
  daily: {
    interval: any;
  };
  handleChange: ({ target }: any) => void;
  translations: any;
}

const RepeatDaily = ({
  id,
  daily: { interval },
  handleChange,
  translations,
}: Props) => (
  <div
    className="form-group row d-flex align-items-sm-center"
    css={css`
      display: grid !important;
      grid-template-columns: 64px auto !important;
      grid-template-rows: 24px 38px !important;
      grid-template-areas:
        "title title"
        "input text" !important;
    `}
  >
    <div
      className="col-sm-1 offset-sm-2"
      css={css`
        grid-area: title;
        text-transform: capitalize;
        font-weight: 600;
      `}
    >
      {translateLabel(translations, "repeat.daily.every")}
    </div>
    <div
      className="col-sm-2"
      css={css`
        grid-area: input;
      `}
    >
      <input
        id={`${id}-interval`}
        name="repeat.daily.interval"
        aria-label="Repeat daily interval"
        className="form-control"
        value={interval}
        onChange={numericalFieldHandler(handleChange)}
      />
    </div>
    <div
      className="col-sm-1"
      css={css`
        grid-area: text;
      `}
    >
      {translateLabel(translations, "repeat.daily.days")}
    </div>
  </div>
);

export default RepeatDaily;
